/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Grid_System_TitleInputs */



/**
* | output |
* | --- |
* | "Character/Line Grid System" |
*
* @param {Options_Display_Grid_System_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_grid_system_title = /** @type {((inputs?: Options_Display_Grid_System_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Grid_System_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Système de grille caractères/lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeichen-/Linienrastersystem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sistema di griglia di caratteri/linee")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Система сетки символов/строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sistema de cuadrícula de caracteres/líneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字符/线网格系统")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字/行グリッドシステム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षर/रेखा ग्रिड प्रणाली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sistema de grade de caracteres/linhas")
	return /** @type {LocalizedString} */ ("Character/Line Grid System")
});